import React from "react";
import { Box, Typography, Container, Chip } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import StorefrontIcon from "@mui/icons-material/Storefront";
import DiamondIcon from "@mui/icons-material/Diamond";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const features = [
  { icon: <DiamondIcon sx={{ fontSize: 22, color: "#FFC001" }} />, label: "Exclusive Merch" },
  { icon: <LocalOfferIcon sx={{ fontSize: 22, color: "#FFC001" }} />, label: "Member Discounts" },
  { icon: <EmojiEventsIcon sx={{ fontSize: 22, color: "#FFC001" }} />, label: "Limited Drops" },
];

const Shop = () => {
  return (
    <>
      <Helmet>
        <meta property="og:image" content="https://prodappdata.s3.amazonaws.com/preview-images/shop-preview.png" />
        <meta property="og:title" content="Shop" />
        <meta property="og:description" content="Moore Exotics Shop" />
      </Helmet>

      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "#0d0d0d",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background glows */}
        <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
          <Box sx={{ position: "absolute", top: "10%", left: "50%", transform: "translateX(-50%)", width: "600px", height: "600px", borderRadius: "50%", background: "radial-gradient(circle, rgba(255,192,1,0.07) 0%, transparent 70%)" }} />
          <Box sx={{ position: "absolute", bottom: "-10%", right: "-5%", width: "400px", height: "400px", borderRadius: "50%", background: "radial-gradient(circle, rgba(255,192,1,0.04) 0%, transparent 70%)" }} />
        </Box>

        {/* Decorative grid lines */}
        <Box sx={{ position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,192,1,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,192,1,0.03) 1px, transparent 1px)", backgroundSize: "60px 60px", pointerEvents: "none" }} />

        <Container maxWidth="sm" sx={{ position: "relative", zIndex: 1, textAlign: "center", py: 8 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            {/* Icon badge */}
            <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: "20px",
                  backgroundColor: "rgba(255,192,1,0.1)",
                  border: "1px solid rgba(255,192,1,0.25)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 0 40px rgba(255,192,1,0.12)",
                }}
              >
                <StorefrontIcon sx={{ fontSize: 38, color: "#FFC001" }} />
              </Box>
            </Box>

            {/* Coming Soon chip */}
            <Chip
              label="COMING SOON"
              size="small"
              sx={{
                backgroundColor: "rgba(255,192,1,0.12)",
                color: "#FFC001",
                fontWeight: 700,
                fontSize: "11px",
                letterSpacing: "0.1em",
                border: "1px solid rgba(255,192,1,0.3)",
                mb: 2.5,
              }}
            />

            {/* Title */}
            <Typography
              sx={{
                color: "#fff",
                fontWeight: 800,
                fontSize: { xs: "32px", sm: "44px", md: "52px" },
                lineHeight: 1.1,
                mb: 2,
              }}
            >
              Moore Exotics{" "}
              <Box component="span" sx={{ color: "#FFC001" }}>
                Shop
              </Box>
            </Typography>

            {/* Subtitle */}
            <Typography
              sx={{
                color: "#777",
                fontSize: { xs: "14px", md: "16px" },
                lineHeight: 1.8,
                maxWidth: "420px",
                mx: "auto",
                mb: 4,
              }}
            >
              Exclusive merch, limited drops, and member-only deals are on their way.
              Be the first to know when we launch.
            </Typography>

            {/* Feature chips */}
            <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5, flexWrap: "wrap", mb: 5 }}>
              {features.map((f) => (
                <Box
                  key={f.label}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.8,
                    backgroundColor: "#1a1a1a",
                    border: "1px solid #2a2a2a",
                    borderRadius: "10px",
                    px: 1.8,
                    py: 0.9,
                  }}
                >
                  {f.icon}
                  <Typography sx={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>{f.label}</Typography>
                </Box>
              ))}
            </Box>

          </motion.div>
        </Container>
      </Box>
    </>
  );
};

export default Shop;
